import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { FloatingCta } from './components/FloatingCta';
import { PurchasePopup } from './components/PurchasePopup';
import { Hero } from './components/sections/Hero';
import { StatsBar } from './components/sections/StatsBar';
import { BeforeAfter } from './components/sections/BeforeAfter';
import { PainPoints } from './components/sections/PainPoints';
import { ContentSection } from './components/sections/ContentSection';
import { Delivery } from './components/sections/Delivery';
import { Bonuses } from './components/sections/Bonuses';
import { Offer } from './components/sections/Offer';
import { Reflection } from './components/sections/Reflection';
import { Guarantee } from './components/sections/Guarantee';
import { Testimonials } from './components/sections/Testimonials';
import { About } from './components/sections/About';
import { Faq } from './components/sections/Faq';
import { FinalCall } from './components/sections/FinalCall';
import { Footer } from './components/sections/Footer';
type AppProps = {
  showSocialProofPopup?: boolean;
  showFloatingCta?: boolean;
};
export function App({
  showSocialProofPopup = true,
  showFloatingCta = true
}: AppProps) {
  return <div className="w-full overflow-x-hidden bg-bone font-sans text-ink antialiased" data-id="element-0" data-mp="3rdkg22e4udm8">
      <MetaPixel data-id="element-1" data-mp="4wupmfw6qeo" />
      {showSocialProofPopup ? <PurchasePopup data-id="element-2" data-mp="82j0zgp5o9c" /> : null}

      <Hero data-id="element-3" data-mp="2zllf11m4wkmq" />
      <main data-id="element-4" data-mp="2zlv7qwykd5w4">
        <StatsBar data-id="element-5" data-mp="2zmepodo7rua5" />
        <BeforeAfter data-id="element-6" data-mp="2zmwi0z7r9ocs" />
        <PainPoints data-id="element-7" data-mp="2zng2onosiqui" />
        <ContentSection data-id="element-8" data-mp="33mf623uvifju" />
        <Delivery data-id="element-9" data-mp="33nq4do5juv3k" />
        <Bonuses data-id="element-10" data-mp="33n6xd2hftr4b" />
        <Offer data-id="element-11" data-mp="33orki71fa7s5" />
        <Reflection data-id="element-12" data-mp="38lrq6gud18iq" />
        <Guarantee data-id="element-13" data-mp="38l8hlqqlnwhd" />
        <Testimonials data-id="element-14" data-mp="38kqgafp2ys2l" />
        <About data-id="element-15" data-mp="38kgmsi4tu2s5" />
        <Faq data-id="element-16" data-mp="38o4h3ji3it7x" />
        <FinalCall data-id="element-17" data-mp="3dkus3sf1mymh" />
      </main>
      <Footer data-id="element-18" data-mp="3dlw6a5rcw18f" />

      {showFloatingCta ? <FloatingCta data-id="element-19" data-mp="3dm5vvs8ho6dl" /> : null}
    </div>;
}